import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-background-dark border-t border-[#e4e3dc] dark:border-[#3a362a] pt-20 pb-10">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div className="space-y-6">
          <div className="flex items-center gap-2">
            <div className="text-primary">
              <img loading="lazy"
                src="public/assets/favicon.png"
                alt="Favicon"
                className="size-6"
              />
            </div>
            <span className="text-xl font-serif font-bold text-primary">
              Jati Antik Furniture
            </span>
          </div>
          <p className="text-sm text-[#857d66] leading-relaxed">
            Dedikasi kami adalah menghadirkan warisan budaya Indonesia melalui
            furnitur kayu jati berkualitas tinggi yang bertahan hingga generasi
            mendatang.
          </p>
          <div className="flex gap-4">
            <a
              className="size-10 rounded-full border border-primary/30 flex items-center justify-center text-[#171612] dark:text-white hover:bg-primary hover:text-white transition-all"
              href="#"
            >
              <FontAwesomeIcon icon={faFacebook} className="text-lg" />
            </a>
            <a
              className="size-10 rounded-full border border-primary/30 flex items-center justify-center text-[#171612] dark:text-white hover:bg-primary hover:text-white transition-all"
              href="#"
            >
              <FontAwesomeIcon icon={faTiktok} className="text-lg" />
            </a>
            <a
              className="size-10 rounded-full border border-primary/30 flex items-center justify-center text-[#171612] dark:text-white hover:bg-primary hover:text-white transition-all"
              href="#"
            >
              <FontAwesomeIcon icon={faInstagram} className="text-lg" />
            </a>
          </div>
        </div>
        <div className="space-y-6">
          <h5 className="font-bold text-[#171612] dark:text-white">Navigasi</h5>
          <ul className="space-y-4 text-sm text-[#857d66]">
            <li>
              <Link className="hover:text-primary" to="/">
                Beranda
              </Link>
            </li>
            <li>
              <Link className="hover:text-primary" to="/products">
                Produk
              </Link>
            </li>
            <li>
              <Link className="hover:text-primary" to="/articles">
                Artikel
              </Link>
            </li>
            <li>
              <Link className="hover:text-primary" to="/gallery">
                Galeri
              </Link>
            </li>
            <li>
              <Link className="hover:text-primary" to="/contact">
                Kontak
              </Link>
            </li>
            <li>
              <Link className="hover:text-primary" to="/about">
                tentang Kami
              </Link>
            </li>
          </ul>
        </div>
        <div className="space-y-6">
          <h5 className="font-bold text-[#171612] dark:text-white">Bantuan</h5>
          <ul className="space-y-4 text-sm text-[#857d66]">
            <li>
              <Link className="hover:text-primary" to="/help">
                Cara Pemesanan
              </Link>
            </li>
            <li>
              <Link className="hover:text-primary" to="/shipping">
                Kebijakan Pengiriman
              </Link>
            </li>
            <li>
              <Link className="hover:text-primary" to="/warranty">
                Garansi Produk
              </Link>
            </li>
            <li>
              <Link className="hover:text-primary" to="/faq">
                FAQ
              </Link>
            </li>
          </ul>
        </div>
        <div className="space-y-6">
          <h5 className="font-bold text-[#171612] dark:text-white">
            Hubungi Kami
          </h5>
          <ul className="space-y-4 text-sm text-[#857d66]">
            <li className="flex items-start gap-3">
              <span className="material-symbols-outlined text-primary text-xl">
                location_on
              </span>
              <span>Ds. Cepogo rt 03 rw 09 Kec. Kembang Kab. jepara, 59457</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="material-symbols-outlined text-primary text-xl">
                call
              </span>
              <span>+62 812 3456 7890</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="material-symbols-outlined text-primary text-xl">
                mail
              </span>
              <span>info@jatiantik.com</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 mt-20 pt-10 border-t border-[#e4e3dc] dark:border-[#3a362a] flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#857d66]">
        <p>© 2024 Jati Antik Indonesia. Hak Cipta Dilindungi.</p>
        <div className="flex gap-6">
          <Link className="hover:text-primary" to="/terms">
            Terms of Service
          </Link>
          <Link className="hover:text-primary" to="/privacy">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
